<template>
  <div class="flex w-full flex-col gap-y-[42px] text-right laptop:gap-y-[56px]">
    <GridsTwelveGrid class="z-10 col-span-1 col-start-2 mb-7 gap-y-10 laptop:gap-y-14">
      <h2 class="col-span-4 col-start-1 text-left laptop:col-span-2 laptop:col-start-9 laptop:mr-8 laptop:text-right">
        {{ data?.companyPage?.data?.attributes?.history_title }}
      </h2>

      <template v-for="item in first3" :key="item.id || JSON.stringify(item)">
        <h4 class="col-span-4 col-start-1 text-right text-lg laptop:col-span-5 laptop:col-start-4 laptop:text-[20px]">
          {{ item?.text }}
        </h4>
        <h4 class="col-span-2 col-start-5 text-center text-lg laptop:col-span-1 laptop:col-start-10 laptop:text-[20px]">
          {{ item?.year }}
        </h4>
      </template>
    </GridsTwelveGrid>
  </div>
</template>
<script setup>
import { Companypage2DataKey } from "~/symbols/symbols";
const data = inject(Companypage2DataKey);

const first3 = computed(() => {
  return data.value?.companyPage?.data?.attributes?.history_details?.slice(0, 3);
});
</script>
<style lang="scss" scoped></style>
